import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    padding: 10,

    '& p': {
      padding: '5px 0 0 5px',
    },
  },

  score: {
    marginTop: 20,
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    '& span': {
      fontSize: 14,
    },
  },

  expansibleContent: {
    padding: 10,
    backgroundColor: '#EFEFEF',
  },

  errorCaptured: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: 5,
  },

  companyInfo: {
    padding: 10,
    fontWeight: 'normal',
  },
}))
